import React from 'react';
import { ArrowRight } from 'lucide-react';
interface GlowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function GlowButton({
  children,
  className = '',
  ...props
}: GlowButtonProps) {
  return <button className={`
        relative group flex items-center justify-center gap-2
        bg-gradient-to-r from-blue-600 to-purple-600
        text-white font-semibold tracking-[0.04em]
        text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-4 rounded-full
        transition-all duration-300 ease-out
        hover:scale-105 hover:from-blue-500 hover:to-purple-500
        active:scale-[0.98]
        animate-glow-pulse
        ${className}
      `} {...props} data-id="element-134">
      <span data-id="element-135">{children}</span>
      <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 transition-transform group-hover:translate-x-1" data-id="element-136" />

      {/* Inner highlight for 3D feel */}
      <div className="absolute inset-0 rounded-full ring-1 ring-white/20 pointer-events-none" data-id="element-137" />
    </button>;
}